import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoanTenureSelectorComponent } from './loan-tenure-selector.component';
import { MatInputModule, MatRadioModule } from '@angular/material';
import { FormsModule } from '@angular/forms';

@NgModule({
  exports: [LoanTenureSelectorComponent],
  declarations: [LoanTenureSelectorComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatRadioModule,
    MatInputModule
  ]
})
export class LoanTenureSelectorModule { }
